import React, { useEffect, useState } from 'react'
import {motion } from 'framer-motion'
import axios from 'axios'

const ContactMe = ({setCursorVariant,setMessage}) => {
    const [name, setName] = useState('')
    const [comment, setComment] = useState('')
    const [success, setSuccess] = useState(false)

    const sendPost = async (a, b) => {
        try {
            await axios.post('https://portfolio-api-rz8v.onrender.com/users',
                {
                    username: name,
                    comment: comment
                }
            )
            
        } catch (error) {
            console.log(error)
        }
    }
    
    const handleClick = (e) => {
        e.preventDefault();
        if (!name || !comment) {
            alert("please fill both inputs")
        } else {
            sendPost({ name, comment })
                setSuccess(true)
            }
        setName('')
        setComment('')
        setTimeout(() => {
            setSuccess(false)
        }, 2000);
    }

    useEffect(() => {
        const sendPostManually = async (a, b) => {
            try {
                await axios.post('https://portfolio-api-rz8v.onrender.com/users',
                    {
                        username: 'someone',
                        comment: new Date()
                    }
                )
                
            } catch (error) {
                console.log(error)
            }
        }
        sendPostManually()
    }, []);

    return (
        <div className="container contactMe my-5">
            <motion.div initial={{ x: -300, }} whileInView={{ x: 0, opacity: 1 }} transition={{ type: "spring" }}>
                
                <h1>send me a message</h1>
                <form >
                    <input className='my-3' type="text" placeholder='your name' required value={name} onChange={(e) => setName(e.target.value)}  />
                    <textarea className='my-3' name="" id="" placeholder='what do you want to tell me' required value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
                    <motion.div className='my-3' whileHover={{ scale: 1.2 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <button onClick={handleClick}>send</button>
                    </motion.div>
                <h6 style={success?{display:'block'}:{display:"none"}}>sent successfully!</h6>
                </form>
            </motion.div>

        </div>
    )
};

export default ContactMe